import { render, staticRenderFns } from "./editPw.vue?vue&type=template&id=001062d2&scoped=true&"
import script from "./editPw.vue?vue&type=script&lang=js&"
export * from "./editPw.vue?vue&type=script&lang=js&"
import style0 from "./editPw.vue?vue&type=style&index=0&id=001062d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001062d2",
  null
  
)

export default component.exports